export const PilotCategories = {
  PetFood: 'pet-food',
  HealthAndFitness: 'health-and-fitness',
};
